export const inputTextMixins = {
    data() {
        return {
            typingTimer : null,
            doneTypingInterval: 1000,
        }
    },
    methods: {
        delayTyping(functionToExecute) {
            clearTimeout(this.typingTimer);
            this.typingTimer = setTimeout( () => {
                functionToExecute();
            }, this.doneTypingInterval);
        },
        formatMobileNumberOnPaste(inputText){
            if(!inputText || !inputText.trim()){
                return "";
            }

           // Remove all non-numeric characters except dashes
			const cleaned = inputText.replace(/[^\d]/g, '');

			// Format number into two groups
			const firstPart = cleaned.slice(0, 4);
			const secondPart = cleaned.slice(4, 10);

			// Join parts with a dash
			const formattedMobileNumber = secondPart.length > 0 ? `${firstPart}-${secondPart}`.slice(0, 11) : firstPart;
            
            return formattedMobileNumber;
        }, 
        formatMobileNumberOnChange(event){
            let inputText = event.target.value;
            if(!inputText || !inputText.trim()){
                return "";
            }

			const input = event.target;
			const cursorPos = input.selectionStart;

			// Clean and format the input value
			const cleanedText = input.value.replace(/[^\d]/g, '');

			let formattedText = cleanedText;
			// Add a dash only if there are more than 4 numeric characters
			if (cleanedText.length > 4) {
				formattedText = cleanedText.replace(/(\d{4})(\d{0,})/, '$1-$2');
			} else {
				formattedText = cleanedText;
			}

			// Calculate the cursor position adjustment
			let newCursorPos = cursorPos;
			if (formattedText.length > input.value.length && cursorPos > 4) {
				newCursorPos += 1; // Move cursor right if a dash was added
			} else if (formattedText.length < input.value.length && cursorPos > 4) {
				newCursorPos -= 1; // Move cursor left if a character was removed
			}
            
			// Update the value and cursor position
			this.$nextTick(() => {
                input.value = formattedText;
				input.selectionStart = newCursorPos;
				input.selectionEnd = newCursorPos;
			});

            return formattedText;
        }
    }
}